import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  SelectScenarioContextProvider,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/SelectScenarioContext';
import RoadmapExecutiveSummaryContainerForDeliverable
  from 'Views/Page/Content/Templates/RoadmapExecutiveSummaryTemplate/RoadmapExecutiveSummaryContainerForDeliverable';
import { FDContentContainer, FDStack } from '@facet-wealth/design';
import { RightColumnProvider } from 'Context/RightColumnContext';
import ScenarioQuestionPicker
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/ScenarioQuestionPicker';
import { RoadmapDeliverableLeftNav } from 'Components/UI/roadmapDeliverable/leftNav';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { dataAttrs } from 'Helpers/Testing';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import fr from 'facet-rest';
import { noop } from 'Helpers/PropTypes';
import { RoadmapDeliverableHeader } from '../Wrapper/RoadmapDeliverableHeader';
import { RoadmapDeliverableNav } from '../Wrapper/RoadmapDeliverableNav';

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const { loadModalCollectionByLink } = useModalContext();
  useBoneBackgroundColor();

  const proposalExpirationRel = resource.withRelationship(
    fr.relationships.proposalExpiration.name,
    (rel) => rel,
    () => null,
  );

  const roadmapDeliverableIntroWizardRel = resource.withRelationship(
    fr.relationships.roadmapDeliverableIntroWizard.name,
    (rel) => rel,
    () => null,
  );

  useComponentDidMount(() => {
    if (proposalExpirationRel) {
      loadModalCollectionByLink(proposalExpirationRel.link('related').url());
      return;
    }

    if (roadmapDeliverableIntroWizardRel) {
      loadModalCollectionByLink(roadmapDeliverableIntroWizardRel.link('related').url());
    }
  });

  if (!resource) {
    return null;
  }

  // This step does not use the Roadmap Deliverable Wrapper due to the custom disclaimers at the bottom.
  // If this becomes a more common patter in this wizard, we can refactor this to use the wrapper.
  return (
    <RightColumnProvider>
      <FDContentContainer maxWidth={'xl'} {...dataAttrs('your-roadmap-is-ready-template-content')}>
        <RoadmapDeliverableNav navAwayRelationship={resource.relationship(fr.relationships.navigateAway.name)} />
        <FDStack direction={'column'} justifyContent={'center'} alignItems={'center'} paddingY={4} spacing={4}>
          <RoadmapDeliverableHeader resource={resource} />
          <SelectScenarioContextProvider onSelectSuccess={noop}>
            <RoadmapExecutiveSummaryContainerForDeliverable resource={resource} />
          </SelectScenarioContextProvider>
        </FDStack>
        <ScenarioQuestionPicker />
        <RoadmapDeliverableLeftNav />
      </FDContentContainer>
    </RightColumnProvider>
  );
};

export default Layout;
